export default "__VITE_PUBLIC_ASSET__fb3f1422__"